function InterventionList() {
    /// <summary>
    /// This object provides common functions for the Widget.Intervention.List. <br/>
    /// Author: ARF<br />
    /// Date: 22.10.2015<br />
    /// Copyright ©: EUDT GmbH 2015 <br />
    /// Version-History:<br />
    /// **********************************************************************<br />
    /// *** v1.0.1 - 18.1.2017                                               *<br />
    /// **********************************************************************<br />
    /// * - handles monthly and yearly intervals now                         *<br />
    /// **********************************************************************<br />
    /// *** v1.0.0 - 22.10.2015                                               *<br />
    /// **********************************************************************<br />
    /// * - basic functionality                                              *<br />
    /// **********************************************************************<br />
    /// </summary>
}
InterventionList.prototype = new vcTemplate();

InterventionList.prototype.init = function () {
    /// <summary>
    /// This function inits all checkbox event handlers, radio buttons, datepickers and buttons.
    /// </summary>
  var me = this;
    try {
      if (me.error) { return false; }
      me.showInfo("", "", false);

     //init list entry click handler
      me.showDetailHandler();
      return true;
    } catch (ex) { me.writeError('init', ex); return false; }
};



InterventionList.prototype.showDetailHandler = function () {
    /// <summary>
    /// This function inits the click handler for one single entry and loads the detail view. <br/>
    /// </summary>
    var me = this;
    try {

        if (me.error) { return false; }
        //init list entry click handler
        me.visual.find('li.vc-list-item').unbind('click').click(function() {
            var obj = $(this);
            var id = parseInt(obj.attr('data-id'),10);  
            if (me.visual.find('#divDetail' + id).hasClass('visible')) {
                me.visual.find('#divDetail' + id).removeClass('visible').hide().html('');
                obj.removeClass('visible');
            } else {

                me.visual.find('#divDetail' + id).html(me.vcC.getLoadingIcon());
                //get a list of signals for the given intervention
                window.VisualCoreService.getData(me.vcvid, me.vcgid, getCurrentTimestamp(), 0, 0, '', '', me.deviceType, me.langid, id,
                    function (result) {
                        if (result === null) { me.showMessage(me.resources.err_loadData,true);return false;}
                       
                        obj.addClass('visible');
                        me.visual.find('#divDetail' + id).addClass('visible').show();
                        if (result.rows === null) {
                            me.visual.find('#divDetail' + id).html("<div class='error'>" + me.resources.noEntriesExist + "</div>");

                        } else {
                            me.fillDetail(id, result);
                        }
                        return true;
                    });
            }
        });
  
      return true;
    } catch (ex) { me.writeError('showDetailHandler', ex); return false; }
};



InterventionList.prototype.fillDetail = function (id, result) {
    /// <summary>
    /// This function fills the detail placeholder for one entry with a ramp chart for the current month and all signals of the given intervention.
    /// </summary>
    var me = this;
    var signalParam = { 'series': [] };
    var param;
    try {
        if (me.error) { return false; }

        if (result.rows.length === 0) {return false}
        var objDetail = me.visual.find('#divDetail' + id);
        objDetail.html(me.vcC.getLoadingIcon());
        param = { 'loggerID': result.rows[0].blid, 'UseSimpleBottomLegend': true, 'ShowInvalidValues': true, 'ShowPlotLines': true, 'DateUserDef': true, 'datatype': 2, 'ShowIntervention': true, 'ShowEmptyChart': true, 'ShowExportIcons': false };
        for (var i = 0; i < result.rows.length; i++) {
            signalParam.series.push({ 'bsaid': [result.rows[i].bsaid], 'rule': '[bsaid=' + result.rows[i].bsaid + ']', 'ruleType': 1, 'guid': result.rows[i].bsaid, 'edit': false });
        }

        param.startDate = me.startDate;
        param.endDate = me.endDate;

        me.vcVisual.addVisualBaseByName('divDet', 'VISUAL_RAMP_DAILY', 'ail' + id, getCurrentTimestamp(), parseInt(objDetail.height(), 10), parseInt(objDetail.width(), 10) - 20, JSON.stringify(param), JSON.stringify(signalParam), me.deviceType);
        return true;
    } catch (ex) { me.writeError('fillDetail', ex); return false; }
};


InterventionList.prototype.doEvent = function () {
    /// <summary>
    /// Not needed here right now ...
    /// </summary>

};


InterventionList.prototype.specificInfoHandling = function (bError) {
    /// <summary>
    /// This function  hides/fades out content on error state. 
    /// </summary>
    var me = this;
    try {
        if (bError) {
            me.visual.find('#divHeader, #listHeader, .vc-list').hide();
        }
        return true;
    } catch (ex) { me.writeError('specificInfoHandling', ex); return false }
};


